import React, { useEffect } from 'react'
import { Box } from '@mui/system';

const RazorpayCheckout = ({paymentObject, onPaymentSuccess}) => {
  useEffect(() => {
    if(paymentObject){
      launchPaymentGateway(paymentObject);
    }
  }, [paymentObject]);

  const buildPaymentData = (obj) => {
    var config = {
      "key": "rzp_live_9rl59925NTnKng", // Enter the Key ID generated from the Dashboard
      "amount": obj.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      "currency": "INR",
      "name": obj.merchantName,
      "description": obj.description,
      // "image": "https://webook.org/assets/images/icon.png",
      "order_id": obj.transactionId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      "handler": function (response){
        paymentSuccess(response)
      },
      "prefill": {
          "name": "Naveen Kumar",
          "email": "ramukneevannv@gmail.com",
          "contact": "9738221264"
      },
      "theme": {
          "color": "#F8DD07"
      }
    };
    return config;
  }

  const launchPaymentGateway = (obj) => {
    const config = buildPaymentData(obj);
    const Razorpay = window.Razorpay;
    if(Razorpay ){
      var rzp1 = new Razorpay(config);
      rzp1.open();
      rzp1.on('payment.failed', function (response){
        paymentFailed(response)
      });
    } 
  }

  function paymentFailed(response) {
    console.log('paymentFailed', response)
  }
  
  function paymentSuccess(response) {
    onPaymentSuccess(response);
  }

  return (
    <Box></Box>
  );
}
 
export default RazorpayCheckout;

